// Configure cola layout options
const colaOptions = {
  name: "cola",
  animate: true, // whether to show the layout as it's running
  refresh: 1, // number of ticks per frame; higher is faster but more jerky
  maxSimulationTime: 15000, // max length in ms to run the layout
  fit: true,
  infinite: false,
  padding: 100,
  avoidOverlap: true,
  centerGraph: true,
  ungrabifyWhileSimulating: false,
  convergenceThreshold: 0.01,
  nodeDimensionsIncludeLabels: false, // whether labels should be included in determining the space used by a node
  boundingBox: undefined, // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
  // positioning options
  handleDisconnected: true, // if true, avoids disconnected components from overlapping

  // different methods of specifying edge length
  // each can be a constant numerical value or a function like `function( edge ){ return 2; }`
  edgeLength: 110, // sets edge length directly in simulation
  edgeSymDiffLength: undefined, // symmetric diff edge length in simulation
  edgeJaccardLength: undefined, // jaccard edge length in simulation

  // iterations of cola algorithm; uses default values on undefined
  unconstrIter: undefined, // unconstrained initial layout iterations
  userConstIter: undefined, // initial layout iterations with user-specified constraints
  allConstIter: undefined, // initial layout iterations with all constraints including non-overlap
};

export default colaOptions;
